import { createAsyncThunk } from '@reduxjs/toolkit';
import { loadLatestProjectsClockedInTo } from 'store/projects/thunks/loadLatestProjectsLoadedIn.thunk';
import { updateUserActiveEmployer } from './updateUserActiveEmployer.thunk';

export const handleChangeActiveEmployer = createAsyncThunk(
  'user/handleChangeActiveEmployer',
  async (
    { activeEmployerId, history, navigateToEmployer = false },
    { dispatch }
  ) => {
    await dispatch(
      updateUserActiveEmployer({
        activeEmployerId,
        history,
        navigateToEmployer,
      })
    );

    dispatch(loadLatestProjectsClockedInTo());
  }
);
